import { useEffect } from 'react';

const useScript = (url: string, callback: (args?: any) => void, args?: any) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = false;

    document.body.appendChild(script);

    script.onload = function() {
      callback(args);
    };

    return () => {
      document.body.removeChild(script);
    }
  });
};

export default useScript;